export default {
	datatype: {
		create: {
			label: "Neuer Typ",
			placeholder: "Neuer Typ — benennen und ↵ drücken",
		},
		owner: {
			label: "Anzeigen",
			all: "Alle",
			local: "Dieses Projekt",
		},
		kind: {
			label: "Art",
			all: "Alle",
			union: "Unions",
			plain: "Keine Unions",
		},
		search: "Typen suchen…",
		noResults: "Keine Typen entsprechen Ihrer Suche.",
		empty: {
			title: "Noch keine Typen",
			hint: "Erstellen Sie Ihren ersten Typ für benutzerdefinierte Aufzählungen.",
		},
		readOnlyNoLabel: "Hierfür gibt es noch keine Bezeichnung, und Sie können keine vergeben.",
		readOnly: "Sie können diesen Typ ansehen, aber nicht ändern.",
		gone: "Diesen Typ gibt es nicht mehr — er wurde gelöscht, während er geöffnet war.",
		deleteConfirm: "Typ „{name}“ löschen?",
		description: {
			add: "Beschreibung hinzufügen",
		},
		list: {
			type: "Typ",
			count: "Anzahl",
			more: "+{count}",
			readOnlyGroup:
				"{count} Typ · hier schreibgeschützt | {count} Typen · hier schreibgeschützt",
		},
		members: {
			title: "Union-Mitglieder",
			hint: "Übernimmt die Werte eines anderen Typs. Dieser Typ lässt dann seine eigenen Werte und die aller Mitglieder zu.",
			placeholder: "Typen zum Übernehmen auswählen…",
			add: "Mitglied zur Union hinzufügen",
			remove: "{name} entfernen",
		},
		memberOf: {
			badge: "Mitglied von {unions}",
			title: "Mitglied von",
			none: "Kein Mitglied einer Union",
			hint: "Seine Werte sind auch Werte dieser Union, eine Änderung hier wirkt sich dort aus. | Seine Werte sind auch Werte dieser Unions, eine Änderung hier wirkt sich dort aus.",
		},
		values: {
			deleted: "Wert „{name}“ gelöscht",
			changeColor: "Farbe ändern",
			undoShortcut: "Zuletzt gelöschten Wert wiederherstellen",
			undoAlt: "Rückgängig: {key} drücken",
			title: "Werte",
			empty: "Keine Werte",
			add: "Wert hinzufügen",
			addHint:
				"↵ fügt ihn hinzu und lässt das Feld offen — mehrere Zeilen einfügen, um alle hinzuzufügen.",
			duplicateLabel: "Dieser Typ hat bereits einen Wert mit dieser Bezeichnung.",
			showInherited: "Übernommene anzeigen",
			openSource: "{type} öffnen",
			orderHint: "Zum Umsortieren ziehen — in dieser Reihenfolge wird ausgewählt.",
			paste: {
				title: "{count} Wert wird hinzugefügt | {count} Werte werden hinzugefügt",
				add: "{count} Wert hinzufügen | {count} Werte hinzufügen",
			},
		},
		clearColor: "Zurücksetzen",
		image: {
			add: "Bild hinzufügen",
			replace: "Bild ersetzen",
			remove: "Bild entfernen",
			hint: "PNG, GIF, JPEG, WebP oder SVG, höchstens 1 MiB. Wird im Operator neben dem Wert angezeigt.",
			drop: "Loslassen, um das Bild zu setzen",
		},
	},
};
